export const numberBox = {
  backgroundColor: 'primary.main',
  borderRadius: 0.5,
  color: 'common.white',
  display: 'inline-block',
  width: '20px',
  height: '20px',
  lineHeight: '20px',
  marginRight: 1,
  fontSize: '14px'
};
